export default "__VITE_ASSET__DulvZt6J__"